
import { defineComponent, PropType } from "vue";

import ResourceIcon from "@/components/Elements/ResourceIcon.vue";

import Port from "@/models/Port";
import Resource from "@/models/Resource";

export default defineComponent({
  props: {
    port: { type: Object as PropType<Port>, required: true },
  },
  computed: {
    resource(): Resource | null {
      if (this.port.accepts.length === 1) {
        return this.port.accepts[0];
      } else {
        return null;
      }
    },
  },
  components: { ResourceIcon },
});
